import '../../src/js/components/tabs.js';

document.addEventListener('DOMContentLoaded', function () {
	const allDetails = document.querySelectorAll('details');

	allDetails.forEach((details) => {
		const summary = details.querySelector('summary');
		const selectedTabSpan = summary.querySelector('.selected-tab');
		const tabList = details.querySelector('[role="tablist"]');

		if (!tabs) {
			return;
		}

		const tabs = tabList.querySelectorAll('[role="tab"]');

		tabs.forEach((tab) => {
			tab.addEventListener('click', (event) => handleTabClick(event, tabs, selectedTabSpan, details));
		});

		updateSummary(tabs, selectedTabSpan, details);
		handleResize(details);

		window.addEventListener('resize', () => handleResize(details));
	});
});

function updateSummary(tabs, selectedTabSpan, details) {
	const selectedTab = Array.from(tabs).find((tab) => tab.getAttribute('aria-selected') === 'true');
	if (selectedTab) {
		selectedTabSpan.textContent = selectedTab.textContent;
	}
	// Only remove the "open" attribute if the screen width is 768px or smaller
	if (window.innerWidth <= 768) {
		details.removeAttribute('open');
	}
}

function handleResize(details) {
	if (window.innerWidth <= 768) {
		details.removeAttribute('open');
	} else {
		details.setAttribute('open', 'true');
	}
}

function handleTabClick(event, tabs, selectedTabSpan, details) {
	tabs.forEach((tab) => tab.setAttribute('aria-selected', 'false'));
	event.target.setAttribute('aria-selected', 'true');
	updateSummary(tabs, selectedTabSpan, details);
}
